<template>
  <span>
    Per Page
    <select v-model="value" v-bind:change="$emit('change')">
      <option value=50>50</option>
      <option value=100>100</option>
      <option value=150>150</option>
    </select>
  </span>
</template>

<script>
export default {
  name: 'AccountDirNumPerPage',

  computed : {
    value : {
      get : function(){
        return this.$store.state.account.num_per_page;
      },

      set : function(v){
        this.$store.commit('set_accounts_per_page', v);
      }
    },

    ivalue : {
      get : function(){
        return this.$route.query.num;
      }
    }
  },

  created : function(){
    if(this.ivalue){
      this.value = this.ivalue;
      this.$emit('change');
    }
  }
}
</script>

<style scoped>
</style>
